import React from "react";
import { useNavigate } from "react-router-dom";
import { GenericTable } from "@shared/components/GenericTable";
import { TableColumn } from "@shared/types/table";
import { useGetSubResources } from "@features/mx/resources/hook";

interface SubResourcesTabProps {
  resource: any;
}

export default function SubResourcesTab({ resource }: SubResourcesTabProps) {
  const { data: subResourcesData } = useGetSubResources({ resourceId: resource?.id });

  // Sub Resources Columns definition
  const subResourcesColumns: TableColumn<any>[] = [
    { key: "meterNumber", header: "Resource ID", type: "text" },
    { key: "deviceNo", header: "Serial No", type: "text" },
    { key: "resourceTypeDisplay", header: "Type", type: "text" },
    { key: "resourceSubTypeDisplay", header: "Sub type", type: "text" },
    { key: "productCode", header: "Utility service", type: "text" },
    { key: "classification", header: "Classification", type: "text" },
    {
      key: "physicalStatusLabel",
      header: "Physical status",
      type: "text",
      render: (val) => (
        <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold border ${val === "Installed"
          ? "bg-blue-50 border-blue-200 text-blue-700"
          : "bg-gray-50 border-gray-200 text-gray-700"
          }`}>
          {val}
        </span>
      )
    },
    {
      key: "assignmentStatus",
      header: "Assignment status",
      type: "text",
      render: (val) => (
        <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold border ${val === "Assigned"
          ? "bg-green-50 border-green-200 text-green-700"
          : "bg-gray-50 border-gray-200 text-gray-700"
          }`}>
          {val}
        </span>
      )
    },
  ];
  const navigate = useNavigate();

  return (
    <div className="space-y-4">
      <div className="border border-gray-150 rounded-xl overflow-hidden p-4">
        <GenericTable
          columns={subResourcesColumns}
          data={subResourcesData?.result ?? []}
          actions={[
            {
              label: "View",
              onClick: (row) => navigate(`/mx/manage/resources/view/${row.id}`),
              icon: "Eye",
            }
          ]}
          actionsType="icons"
          rowKey="id"
          onSearch={(val) => console.log("Searching sub resources:", val)}
          searchPlaceholder="Search sub resources..."
        />
      </div>
      {/* <div className="text-xs text-gray-400 font-medium mt-2">
        {subResourcesData.length} sub resource(s) linked to this resource
      </div> */}
    </div>
  );
}
